import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class Request extends CloudObject {

    /**
     * Creates an instance of Request.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(Request);
    }
    
    /**
     * @return {string}
     */
    getRequestor() {
        return this.get(Request.requestorProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRequestor($) {
        return this.observe($, Request.requestorProp);
    }

    /**
     * @return {string}
     */
    getBp() {
        return this.get(Request.bpProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeBp($) {
        return this.observe($, Request.bpProp);
    }

    /**
     * @return {string}
     */
    getPm() {
        return this.get(Request.pmProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePm($) {
        return this.observe($, Request.pmProp);
    }

    /**
     * @return {Date}
     */
    getDate_creation() {
        return this.get(Request.date_creationProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeDate_creation($) {
        return this.observe($, Request.date_creationProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRequestor(transaction, instance, value) {
        transaction.update(instance, Request.requestorProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setBp(transaction, instance, value) {
        transaction.update(instance, Request.bpProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPm(transaction, instance, value) {
        transaction.update(instance, Request.pmProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setDate_creation(transaction, instance, value) {
        transaction.update(instance, Request.date_creationProp, value);
    }

}

// Hardcoded tags
register('018b8af65c141550a8c6', Request);
Request.requestorProp = defineProperty('018b8af6eeb5298cb834');
Request.bpProp = defineProperty('018b8af703d580a1cfe3');
Request.pmProp = defineProperty('018b8af71b85da84bf67');
Request.date_creationProp = defineProperty('018b8b8eb94e64c81a44');
Request.currentStateRel = defineRelation('018b8af76ecd2972aa0b');
